import { IconType } from './icons';

export enum SpaceType {
  // Social = 'social',
  Home = 'home',
  Custom = 'custom',
  // Membership = 'membership',
  // Fan = 'fan',
  // Promotion = 'promotion',
  // InteractiveLearning = 'interactiveLearning',
  // Teamwork = 'teamwork',
  // DailyCourse = 'dailyCourse',
  // Course = 'course',
  // Prayer = 'prayer',
  // Corporate = 'corporate',
  // SelfStudy = 'selfStudy',
  // Competition = 'competition',
  // Tournament = 'tournament',
  // Assessment = 'assessment',
  Managed = 'managed',
}

export enum SpacePrivacyPolicy {
  Public = 'public',
  // PrivateAndVisible = 'privateAndVisible',
  PrivateAndHidden = 'privateAndHidden',
  Personal = 'personal',
}

export enum SpaceMembershipRole {
  Root = 'root', // owner / organizer
  Admin = 'admin',
  Moderator = 'moderator',
  Member = 'member',
  Follower = 'follower',
}

export const SPACE_TYPE: Record<
  SpaceType,
  Readonly<{
    iconSource: IconType;
  }>
> = Object.freeze({
  [SpaceType.Home]: {
    iconSource: IconType.SocialSpace,
  },
  [SpaceType.Custom]: {
    iconSource: IconType.SocialSpace,
  },
  // [SpaceType.Social]: {
  //   iconSource: IconType.SocialSpace,
  // },
  // [SpaceType.Membership]: {
  //   iconSource: IconType.MembershipSpace,
  // },
  // [SpaceType.Fan]: {
  //   iconSource: IconType.FanSpace,
  // },
  // [SpaceType.Promotion]: {
  //   iconSource: IconType.PromotionSpace,
  // },
  // [SpaceType.InteractiveLearning]: {
  //   iconSource: IconType.InteractiveLearningSpace,
  // },
  // [SpaceType.Teamwork]: {
  //   iconSource: IconType.TeamworkSpace,
  // },
  // [SpaceType.DailyCourse]: {
  //   iconSource: IconType.DailyCourseSpace,
  // },
  // [SpaceType.Course]: {
  //   iconSource: IconType.CourseSpace,
  // },
  // [SpaceType.Prayer]: {
  //   iconSource: IconType.PrayerSpace,
  // },
  // [SpaceType.Corporate]: {
  //   iconSource: IconType.CorporateSpace,
  // },
  // [SpaceType.SelfStudy]: {
  //   iconSource: IconType.SelfStudySpace,
  // },
  // [SpaceType.Competition]: {
  //   iconSource: IconType.CompetitionSpace,
  // },
  // [SpaceType.Tournament]: {
  //   iconSource: IconType.CompetitionSpace,
  // },
  // [SpaceType.Assessment]: {
  //   iconSource: IconType.AssessmentSpace,
  // },
  [SpaceType.Managed]: {
    iconSource: IconType.SocialSpace,
  },
});

export enum ClubTemplate {
  TeamBuilding = 'teamBuilding',
  FamilyBonding = 'familyBonding',
  LearnerEngagement = 'learnerEngagement',
  GamifiedMarketing = 'gamifiedMarketing',
  DailyLearning = 'dailyLearning',
  CourseBasedLearning = 'courseBasedLearning',
  LanguageLearning = 'languageLearning',
  Training = 'training',
  Corporate = 'corporate',
  School = 'school',
  Church = 'church',
  Fellowship = 'fellowship',
  Fans = 'fans',
  General = 'general',
}
